var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"base-cancel-button",class:{
  'base-cancel-button_bg': _vm.bg,
},attrs:{"type":"button"},on:{"click":(e) => _vm.$emit('onButtonClicked', e)}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }